import { render, staticRenderFns } from "./answer-card.vue?vue&type=template&id=06a9a0bf&scoped=true&"
import script from "./answer-card.vue?vue&type=script&lang=ts&"
export * from "./answer-card.vue?vue&type=script&lang=ts&"
import style0 from "./answer-card.vue?vue&type=style&index=0&id=06a9a0bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9a0bf",
  null
  
)

export default component.exports